"use client";
import { useDocumentDirection } from "@/hooks/useDocumentDirection";
import Image from "next/image";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const Brands = ({ brands }) => {
  const dir = useDocumentDirection();
  return (
    <div className="section_space_py border-t border-b border-[rgba(45,45,45,0.10)]">
      <div className="brands-slider">
        <Swiper
          spaceBetween={16}
          slidesPerView={1.2}
          modules={[Autoplay]}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          dir={dir}
          key={dir}
          speed={4000}
          loop={true}
          allowTouchMove={false}
          grabCursor={false}
          breakpoints={{
            320: { slidesPerView: 3, spaceBetween: 10 },
            576: { slidesPerView: 4, spaceBetween: 20 },
            768: { slidesPerView: 5, spaceBetween: 20 },
            992: { slidesPerView: 6, spaceBetween: 30 },
            1200: { slidesPerView: 7, spaceBetween: 30 },
            1400: { slidesPerView: 8, spaceBetween: 10 },
            1600: { slidesPerView: 10, spaceBetween: 10 },
            1920: { slidesPerView: 10, spaceBetween: 10 },
          }}
          style={{
            transitionTimingFunction: "linear",
          }}
        >
          {brands.map((brand, index) => {
            return (
              <SwiperSlide key={index}>
                <div className="w-auto h-[30px]">
                  <Image
                    src={brand?.logo}
                    alt="brand"
                    width={100}
                    height={100}
                    unoptimized
                    className="w-full h-full object-contain"
                  />
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};

export default Brands;
